exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".op-select[data-v-0fdf6dfc]{display:inline-block}.op-select .op-select-txt[data-v-0fdf6dfc]{color:#666}\n", ""]);

// exports
